import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import { VIDEO_CONFERENCE_TYPES } from 'constants/config';
import Tooltip from 'components/shared/Tooltip';
import LinkButton from 'components/shared/LinkButton';
import Error from 'components/InPersonTraining/shared/Error';
import PreserveFormatting from 'components/shared/PreserveFormatting/index';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import {
  localTime,
  localTimeZone,
} from 'components/InPersonTraining/shared/LocalTimeAndTimeZone';
import DateFormat from 'constants/date_format';
import EditForm from './EditForm';

class Header extends Component {
  state = {
    editing: false,
  };

  toggleEdit = () => {
    this.setState(state => ({
      editing: !state.editing,
    }));
  };

  constructFormattedDate = () => {};

  render() {
    const { event, session, isArchived, currentUserId, currentSession } =
      this.props;
    const isVideoMeetingHost =
      session?.video_meeting?.host_id === currentUserId ||
      session?.video_meeting?.provider !== VIDEO_CONFERENCE_TYPES.ZOOM;
    const formatDate = (date, format) =>
      moment(date, DateFormat.fixed.ISO8601_LOCAL).format(format);

    const sessionTime = (startTime, timeZone) => {
      const formattedDate = moment(
        localTime(startTime),
        DateFormat.fixed.ISO8601_LOCAL,
      ).format(DateFormat.fixed.SHORT_DAY_WITH_SHORT_MONTH);
      const formattedStartTime = formatDate(
        localTime(currentSession.start_time),
        DateFormat.TIME,
      );
      const formattedEndTime = formatDate(
        localTime(currentSession.end_time),
        DateFormat.TIME,
      );
      const formattedTimeZone = timeZone.formatted && localTimeZone();

      return `${formattedDate}, ${formattedStartTime} - ${formattedEndTime} ${formattedTimeZone}`;
    };

    return (
      <div className="EventOverviewHeader">
        {!isVideoMeetingHost && (
          <Error message={t('in_person_training.errors.non_zoom_host')} />
        )}
        {this.state.editing && <EditForm onDismiss={this.toggleEdit} />}
        {!this.state.editing && (
          <div>
            <div className="d-f jc-sb ai-fs mb-16">
              <h1 className="ff-ss ws-pr mr-8">
                {!currentSession
                  ? event.name
                  : sessionTime(
                      currentSession.start_time,
                      currentSession.time_zone,
                    )}
              </h1>
              {!currentSession && (
                <Tooltip
                  text={
                    isArchived &&
                    t(
                      'in_person_training.event_overview.archived_cannot_be_edited',
                    )
                  }
                >
                  <LinkButton
                    type="primary"
                    disabled={isArchived || !isVideoMeetingHost}
                    className="EventOverviewHeader-editBtn u-linkBtn"
                    onClick={this.toggleEdit}
                  >
                    <Icon name="edit" className="mr-4" />
                    {t('common.edit')}
                  </LinkButton>
                </Tooltip>
              )}
            </div>
            <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
              <PreserveFormatting>
                {this.props.event.description}
              </PreserveFormatting>
            </Text>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  event: state.event,
  isArchived: state.event.is_archived,
  session: state.sessions[0],
  currentUserId: state.meta?.currentUser?.id,
});

export default connect(mapStateToProps)(Header);
